module.exports = __webpack_public_path__ + "img/PredPlan180_ok.083199cc.png";